import { UserAvatar } from '@/components'
import { useAuth } from '@/hooks/common'
import { Note } from '@/types'
import { OpenInNewRounded } from '@mui/icons-material'
import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

interface Props {
  pinNote: Note
  onClickViewOriginal: () => void
}

const PinOwnerInfoView = ({ pinNote, onClickViewOriginal }: Props) => {
  const pinInfo = JSON.parse(pinNote.noteText)
  const { user } = useAuth()
  const navigate = useNavigate()
  const {
    sourceTopicID,
    sourceTopicName,
    sourceTopicType,
    sourceNoteID,
    ownerID,
    ownerProfileName,
    ownerProfileThumbURL,
  } = pinInfo
  const isMyTopic = ownerID == user?.userID

  const onClickAvatar = () => {
    if (!user) return
    if (isMyTopic) {
      navigate(`/profile/me`)
    } else {
      let previewQuery = new URLSearchParams()
      previewQuery.set('id', ownerID)
      navigate(`/profile/user?${previewQuery.toString()}`)
    }
  }

  return (
    <Box sx={{ padding: '14px' }}>
      <Typography
        variant='subtitle1'
        fontWeight={700}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          color: '#f8fafc',
          fontSize: '16px',
          lineHeight: '20px',
          letterSpacing: '-0.02em',
        }}
      >
        {sourceTopicName}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pt: 1.5,
        }}
      >
        <Box
          onClick={onClickAvatar}
          sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}
        >
          <UserAvatar
            borderRadius={100}
            name={ownerProfileName}
            url={ownerProfileThumbURL}
            size={24}
          />
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              color: '#cbd5e1',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {ownerProfileName}
          </Typography>
        </Box>

        <Tooltip title='Open Original'>
          <IconButton
            size='small'
            onClick={(e) => {
              e.stopPropagation()
              onClickViewOriginal()
            }}
            sx={{
              ml: 1,
              color: '#f8fafc',
              '&:hover': {
                backgroundColor: 'rgba(248, 250, 252, 0.12)',
              },
            }}
          >
            <OpenInNewRounded fontSize='small' />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  )
}

export default PinOwnerInfoView
